import { Injectable } from '@angular/core';
import { merge } from 'lodash';
import { Config } from './config.model';
import { GlobalConfigManager } from './global-config-manager';

type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P];
};

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private config: Config;

  constructor() {
    this.config = GlobalConfigManager.tryGetInstance().getConfig();
  }

  getConfig(): Config {
    return this.config;
  }

  updateConfig(config: DeepPartial<Config>): void {
    this.config = merge(this.config, config);
  }
}
